import React from 'react';
import { Card } from 'react-bootstrap';
import PropTypes from 'prop-types';

import { ReportPersonalityBarChart } from './ReportPersonalityBarChart';

export function ReportPersonalityChartSection({ respondent }) {
  const getScore = (trait) => {
    const score = {};
    let mainScore = null;
    let avgTeamScore = null;
    let teamScore = null;
    Object.entries(trait).forEach(([, value]) => {
      if (!value.description) {
        mainScore = value.caption;
        avgTeamScore = Math.round(value.avgTeamPercentile);
        teamScore = value.teamPercentiles;
      }
      score[value.caption] = Math.round(value.percentile);
    });
    return {
      score, mainScore, avgTeamScore, teamScore,
    };
  };

  const plotReport = ({ score, mainScore }) => {
    const scores = Object.keys(score);
    const values = Object.values(score);
    const mainIndex = Object.keys(score).findIndex((s) => s === mainScore);
    scores.splice(mainIndex, 1);
    const mainValue = values.splice(mainIndex, 1);

    const labels = [mainScore, ...scores].reverse();
    const data = [...mainValue, ...values].reverse();
    return <ReportPersonalityBarChart label={labels} data={data} />;
  };

  return (Object.entries(respondent.report).map(
    ([bfiKey, bfiValue]) => (
      <Card key={`report-section-chart-${bfiKey}`} className="pagebreak py-3 my-3">
        <Card.Body>
          <div className="m-3 p-3">
            <h2>{bfiValue[bfiKey].caption}</h2>
          </div>
          <div className="mx-5">{plotReport(getScore(bfiValue))}</div>
          {Object.entries(bfiValue).map(([key, value]) => (key === bfiKey ? null : (
            <div key={key} className="m-3 p-3">
              <h5>{value.caption}</h5>
              <p>{value.description}</p>
            </div>
          )))}
        </Card.Body>
      </Card>
    ),
  ));
}

ReportPersonalityChartSection.propTypes = {
  respondent: PropTypes.shape({
    report: PropTypes.shape({
      Neuroticism: PropTypes.shape({
        Anixiety: PropTypes.shape({
          percentile: PropTypes.number,
          description: PropTypes.string,
          caption: PropTypes.string,
        }),
        Anger: PropTypes.shape({
          percentile: PropTypes.number,
          description: PropTypes.string,
          caption: PropTypes.string,
        }),
        Depression: PropTypes.shape({
          percentile: PropTypes.number,
          description: PropTypes.string,
          caption: PropTypes.string,
        }),
        SelfConsciousness: PropTypes.shape({
          percentile: PropTypes.number,
          description: PropTypes.string,
          caption: PropTypes.string,
        }),
        Immoderation: PropTypes.shape({
          percentile: PropTypes.number,
          description: PropTypes.string,
          caption: PropTypes.string,
        }),
        Vulnerability: PropTypes.shape({
          percentile: PropTypes.number,
          description: PropTypes.string,
          caption: PropTypes.string,
        }),
        Neuroticism: PropTypes.shape({
          percentile: PropTypes.number,
          description: PropTypes.string,
          caption: PropTypes.string,
        }),
      }),
      Extraversion: PropTypes.shape({
        Friendliness: PropTypes.shape({
          percentile: PropTypes.number,
          description: PropTypes.string,
          caption: PropTypes.string,
        }),
        Gregariousness: PropTypes.shape({
          percentile: PropTypes.number,
          description: PropTypes.string,
          caption: PropTypes.string,
        }),
        Assertiveness: PropTypes.shape({
          percentile: PropTypes.number,
          description: PropTypes.string,
          caption: PropTypes.string,
        }),
        ActivityLevel: PropTypes.shape({
          percentile: PropTypes.number,
          description: PropTypes.string,
          caption: PropTypes.string,
        }),
        ExcitementSeeking: PropTypes.shape({
          percentile: PropTypes.number,
          description: PropTypes.string,
          caption: PropTypes.string,
        }),
        Cheerfulness: PropTypes.shape({
          percentile: PropTypes.number,
          description: PropTypes.string,
          caption: PropTypes.string,
        }),
        Extraversion: PropTypes.shape({
          percentile: PropTypes.number,
          description: PropTypes.string,
          caption: PropTypes.string,
        }),
      }),
      Openness: PropTypes.shape({
        Imagination: PropTypes.shape({
          percentile: PropTypes.number,
          description: PropTypes.string,
          caption: PropTypes.string,
        }),
        ArtisticInterests: PropTypes.shape({
          percentile: PropTypes.number,
          description: PropTypes.string,
          caption: PropTypes.string,
        }),
        Emotionality: PropTypes.shape({
          percentile: PropTypes.number,
          description: PropTypes.string,
          caption: PropTypes.string,
        }),
        Adventureousness: PropTypes.shape({
          percentile: PropTypes.number,
          description: PropTypes.string,
          caption: PropTypes.string,
        }),
        Intellect: PropTypes.shape({
          percentile: PropTypes.number,
          description: PropTypes.string,
          caption: PropTypes.string,
        }),
        Liberalism: PropTypes.shape({
          percentile: PropTypes.number,
          description: PropTypes.string,
          caption: PropTypes.string,
        }),
        Openness: PropTypes.shape({
          percentile: PropTypes.number,
          description: PropTypes.string,
          caption: PropTypes.string,
        }),
      }),
      Agreeableness: PropTypes.shape({
        Morality: PropTypes.shape({
          percentile: PropTypes.number,
          description: PropTypes.string,
          caption: PropTypes.string,
        }),
        Altruism: PropTypes.shape({
          percentile: PropTypes.number,
          description: PropTypes.string,
          caption: PropTypes.string,
        }),
        Cooperation: PropTypes.shape({
          percentile: PropTypes.number,
          description: PropTypes.string,
          caption: PropTypes.string,
        }),
        Modesty: PropTypes.shape({
          percentile: PropTypes.number,
          description: PropTypes.string,
          caption: PropTypes.string,
        }),
        Sympathy: PropTypes.shape({
          percentile: PropTypes.number,
          description: PropTypes.string,
          caption: PropTypes.string,
        }),
        Agreeableness: PropTypes.shape({
          percentile: PropTypes.number,
          description: PropTypes.string,
          caption: PropTypes.string,
        }),
      }),
      Conscientiousness: PropTypes.shape({
        SelfEfficicacy: PropTypes.shape({
          percentile: PropTypes.number,
          description: PropTypes.string,
          caption: PropTypes.string,
        }),
        Orderliness: PropTypes.shape({
          percentile: PropTypes.number,
          description: PropTypes.string,
          caption: PropTypes.string,
        }),
        Dutifulness: PropTypes.shape({
          percentile: PropTypes.number,
          description: PropTypes.string,
          caption: PropTypes.string,
        }),
        AchievementStriving: PropTypes.shape({
          percentile: PropTypes.number,
          description: PropTypes.string,
          caption: PropTypes.string,
        }),
        SelfDiscipline: PropTypes.shape({
          percentile: PropTypes.number,
          description: PropTypes.string,
          caption: PropTypes.string,
        }),
        Cautiousness: PropTypes.shape({
          percentile: PropTypes.number,
          description: PropTypes.string,
          caption: PropTypes.string,
        }),
        Conscientiousness: PropTypes.shape({
          percentile: PropTypes.number,
          description: PropTypes.string,
          caption: PropTypes.string,
        }),
      }),
      status: PropTypes.string,
      surveyId: PropTypes.string,
      templateId: PropTypes.string,
      updatedAt: PropTypes.string,
      respondentId: PropTypes.string,
    }),
  }),
};

ReportPersonalityChartSection.defaultProps = {
  respondent: { report: null },
};
